var $12e7bbe01da0d5ad$exports = {};
$12e7bbe01da0d5ad$exports = {
    "loading": `Na\u{10D}\xedtava sa...`,
    "loadingMore": `Na\u{10D}\xedtava sa viac...`
};


export {$12e7bbe01da0d5ad$exports as default};
//# sourceMappingURL=sk-SK.module.js.map
